import * as React from 'react'

import {
  Box,
  Card,
  RadioButton,
  SelectListItem,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'
import { EngagementSettingDaysEnum } from 'generated/resources/graphql'

import ScrollableList from 'modules/core/components/ScrollableList'
import { useCurrentAccessWeekdays } from 'modules/core/hooks/useCurrentAccessWeekdays'
import getDayOfWeekLabel from 'modules/core/lib/getDayOfWeekLabel'
import i18n from 'modules/core/lib/i18n'

import { PulseConfiguration } from 'modules/engagement/lib/pulse'

const engagementDays = [
  'friday',
  'monday',
  'saturday',
  'sunday',
  'thursday',
  'tuesday',
  'wednesday',
] as const

function isEngagementDay(day: string): day is EngagementSettingDaysEnum {
  return engagementDays.some((engagementDay) => engagementDay === day)
}

export const FrequencyStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<PulseConfiguration>) => {
  const weekDays: EngagementSettingDaysEnum[] = useCurrentAccessWeekdays()
    .map((day) => (isEngagementDay(day) ? day : null))
    .filter(Boolean)

  const changeDay = (day: EngagementSettingDaysEnum) => {
    const currentDays = data.days || []
    const exists = currentDays.find((d) => d === day)
    const newDays = exists ? currentDays.filter((d) => d !== day) : [...currentDays, day]

    onDataChanged({ ...data, days: newDays })
  }

  const selectedDays = data.days || []

  return (
    <Box gap="s16">
      <Box gap="s16">
        <Card onClick={() => onDataChanged({ ...data, frequency: 'daily' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.frequency === 'daily'}
                onChange={() => onDataChanged({ ...data, frequency: 'daily' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.frequency.daily.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('engagement.pulse.activation.frequency.daily.description')}
          </Card.Description>
        </Card>
        <Card onClick={() => onDataChanged({ ...data, frequency: 'specificdays' })}>
          <Card.Title
            action={
              <RadioButton
                value="specificdays"
                checked={data.frequency === 'specificdays'}
                onChange={() => onDataChanged({ ...data, frequency: 'specificdays' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.frequency.custom.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('engagement.pulse.activation.frequency.custom.description')}
          </Card.Description>
          <Card.ExpandableContent expanded={data.frequency === 'specificdays'}>
            <Box gap="s8">
              <Box flexDirection="row" gap="s4">
                <ScrollableList size="medium">
                  <Box gap="s8">
                    {weekDays.map((day, index) => (
                      <Box key={index}>
                        <SelectListItem
                          key={index}
                          label={getDayOfWeekLabel(day)}
                          onClick={() => changeDay(day)}
                          selected={selectedDays.includes(day)}
                        />
                      </Box>
                    ))}
                  </Box>
                </ScrollableList>
              </Box>
            </Box>
          </Card.ExpandableContent>
        </Card>
      </Box>
    </Box>
  )
}
